class AwDate extends HTMLElement {

    constructor() {
        super();
    }

    get date(): string {
        return this.getAttribute('date') || "";
    }

    set date(val) {
        if (val) {
            this.setAttribute('date', 'val');
        } else {
            this.removeAttribute('date');
        }
    }

    connectedCallback() {
        this.innerHTML = /*html*/`<span class="info">
      ${new Date(this.date).toLocaleDateString()}
    </span>`;
    }
}

customElements.define("aw-date", AwDate);
